export default __webpack_public_path__ + "static/media/firma.022bc3f4.png";